import { render, staticRenderFns } from "./BusinessPrescriptionsView.vue?vue&type=template&id=1a311f26"
import script from "./BusinessPrescriptionsView.vue?vue&type=script&lang=js"
export * from "./BusinessPrescriptionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports